// Utility functions for username generation and management

const adjectives = [
  'Amazing', 'Brilliant', 'Creative', 'Dynamic', 'Energetic', 'Fantastic', 
  'Graceful', 'Happy', 'Inspiring', 'Joyful', 'Kind', 'Luminous', 
  'Magnificent', 'Noble', 'Optimistic', 'Peaceful', 'Quick', 'Radiant', 
  'Serene', 'Thoughtful', 'Unique', 'Vibrant', 'Wise', 'Zealous',
    'Adventurous', 'Bold', 'Courageous', 'Daring', 'Eager', 
    'Fearless', 'Gallant', 'Heroic', 'Inventive', 'Jubilant', 'Keen'
];

const nouns = [ 
  'Adventurer', 'Builder', 'Creator', 'Dreamer', 'Explorer', 'Finder', 
  'Guardian', 'Helper', 'Innovator', 'Journeyer', 'Keeper', 'Learner', 
  'Maker', 'Navigator', 'Observer', 'Pioneer', 'Questioner', 'Researcher', 
  'Seeker', 'Thinker', 'Understander', 'Visionary', 'Wanderer', 'Xplorer',
  'Yogi', 'Zealot', 'Artist', 'Coder', 'Designer', 'Engineer',
  'Philosopher', 'Scientist', 'Traveler', 'Writer', 'Musician'
];

export const generateRandomUsername = () => {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = Math.floor(Math.random() * 1000);
  
  return `${adjective}${noun}${number}`;
};

export const validateUsername = (username) => {
  const errors = [];
  if (!username || username.trim().length === 0) {
    errors.push('Username is required');
  }
  // Enforce lowercase
  if (username && username !== username.toLowerCase()) {
    errors.push('Username must be in lowercase');
  }
  if (username.length < 3) {
    errors.push('Username must be at least 3 characters long');
  }
  if (username.length > 30) {
    errors.push('Username must be less than 30 characters long');
  }
  if (!/^[a-z0-9_]+$/.test(username)) {
    errors.push('Username can only contain lowercase letters, numbers and underscores');
  }
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const sanitizeUsername = (username) => {
  return username.trim().toLowerCase().replace(/[^a-z0-9_]/g, '');
};
